import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { CTMSMapModule } from '@ruby/shared/components/ctms-map/ctms-map.module';
import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { TrainRouteDialog } from '@ruby/shared/dialogs/unit-train/train-route/components/train-route.dialog';
import { TrainRouteContainer } from '@ruby/shared/dialogs/unit-train/train-route/containers/train-route.container';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [TrainRouteContainer, TrainRouteDialog],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    MatTabsModule,
    CTMSMapModule,
    PipesModule
  ],
  exports: [TrainRouteContainer]
})
export class TrainRouteModule {}
